import { IntlProvider } from '~i18n';
import { ApolloProvider } from '~api';
import { HostPropsContext, type HostPropsContextValue } from '~features/host-props';
import { ThemeProvider } from '~ui/theme-provider';
import { AppErrorBoundary } from '~features/error';
import { TrackingProvider } from '~features/tracking';
import { ViewWrapper } from '~ui/components';
import { JobListingEmployersCarousel as BaseJobListingEmployersCarousel } from './job-listing-employers-carousel';
import { DataProvider, type CarouselInputOptions } from './data-provider';

type Props = HostPropsContextValue &
  CarouselInputOptions & { companyProfilesLimit: number; carouselProfilesQueryLimit: number };

const JobListingEmployersCarousel = (props: Props) => {
  const { platform, categoryId, cityId, companyProfilesLimit, carouselProfilesQueryLimit } = props;

  return (
    <HostPropsContext.Provider value={props}>
      <ThemeProvider platform={platform}>
        <ViewWrapper data-testid="company-profile-employers-carousel-root">
          <IntlProvider>
            <AppErrorBoundary>
              <ApolloProvider>
                <DataProvider
                  categoryId={categoryId}
                  cityId={cityId}
                  companyProfilesLimit={companyProfilesLimit}
                  companyProfilesQueryLimit={carouselProfilesQueryLimit}
                >
                  {({ profiles, loading }) => (
                    <TrackingProvider employerUserId={undefined} loading={loading}>
                      <BaseJobListingEmployersCarousel profiles={profiles} loading={loading} />
                    </TrackingProvider>
                  )}
                </DataProvider>
              </ApolloProvider>
            </AppErrorBoundary>
          </IntlProvider>
        </ViewWrapper>
      </ThemeProvider>
    </HostPropsContext.Provider>
  );
};

export default JobListingEmployersCarousel;
